@if (uploads().length > 0) {
  <section class="uploads-tray" aria-label="File uploads" aria-live="polite">
    @for (upload of uploads(); track upload.id) {
      <div class="upload-item" [class.upload-item--failed]="upload.status === 'failed'">
        <div class="upload-item-header">
          <span class="upload-item-name" [title]="upload.fileName">{{ upload.fileName }}</span>
          @if (upload.status !== 'uploading') {
            <button type="button" class="upload-item-close" aria-label="Dismiss" (click)="dismiss(upload.id)">×</button>
          }
        </div>
        <progress
          class="upload-item-bar"
          max="100"
          [value]="percent(upload)"
          [attr.aria-label]="'Upload progress for ' + upload.fileName"
        ></progress>
        <span class="upload-item-status">{{ statusLabel(upload) }}</span>
      </div>
    }
  </section>
}
